// menu icon is not seen
// logo is not appearing properly
// background should be transparent for homepage and solid color for other pages

import React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { Menu } from "@mui/material";
import MenuIcon from "@mui/material/Menu/Menu";
import Container from "@mui/material/Container";
import { useLocation, Link } from "react-router-dom";
import logo from "../Headers/bitlogo.png";
//import link from "@mui/material/core";
// import Button from "@mui/material/Button";
import Button from "../button/button.component";

import MenuItem from "@mui/material/MenuItem";

const pages = ["Home", "Companies", "Sign Up / Sign In", "Resources"];

const Header = () => {
  const [anchorElNav, setAnchorElNav] = React.useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  // const location = useLocation();
  // const currentLocation = (location.pathname.substring(1));//to get home
  // console.log(pages[2].toLowerCase().replace(/\s+/g, ""))

  return (
    <AppBar
      elevation={0}
      color="primary"
      style={{ position: "fixed", background: "midnightblue" }}
    >
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Typography
            variant="h6"
            component="div"
            sx={{ display: { xs: "none", md: "flex" } }}
          >
            {/* Logo on the appbar */}
            <Toolbar>
              <a href="http://www.bit-bangalore.edu.in">
                <Box
                  component={"img"}
                  sx={{
                    height: 64,
                  }}
                  alt="Logo"
                  src={logo}
                />
              </a>
            </Toolbar>
            {/* <Toolbar >
              <img src="src/assets/logo-01.png" alt="logo"></img>
          </Toolbar> */}
            {/* logo not appearing */}
            {/* <img src="https://user-images.githubusercontent.com/58522375/147961380-9b55a5f9-281f-41f7-b211-2b78363c2a2d.png" alt="logo" /> */}
          </Typography>

          <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon style={{ backgroundColor: "aliceblue" }} />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: "block", md: "none" },
              }}
            ></Menu>
          </Box>
          <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}
          >
            {/* logo not appearing */}
            {/* <Toolbar>
              <img src="src/assets/logo-01.png" alt="logo" ></img>
          </Toolbar> */}
            BIT
          </Typography>
          <Box
            sx={{
              flexGrow: 1,
              display: { xs: "none", md: "flex", lg: "flex" },
            }}
          >
            {pages.map((page, index) => (
              <MenuItem key={index} onClick={handleCloseNavMenu}>
                <Link
                  to={`/${page
                    .toLowerCase()
                    .replace("/", "")
                    .replace(/\s+/g, "")}`}
                  sx={{ color: "white" }}
                >
                  <Typography
                    textAlign="center"
                    sx={{ color: "white", textDecoration: "none" }}
                  >
                    {page}
                  </Typography>
                </Link>
              </MenuItem>
            ))}
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};
export default Header;

//original button component

{
  /* <Button
               key={page}
               style={{ my: 2, color: "white", display: "flex",backgroundColor:"rgba(5, 30, 115, 1)"}}
               buttonLink={page.toLowerCase().replace(/\s+/g, "")}
             >
             {page}
             {console.log(page)}
             </Button> */
}
